import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterSideNav from 'ui-addon-react-router-dom/RouterSideNav';
import { CurrencyPickerContainer } from './CurrencyPickerContainer';
import { useSideNavVisibility } from './hooks/useSideNavVisibility';
import { AddOnsSideNavItem, BundleSideNavItem, CommerceSideNavItem, ContentSideNavItem, CustomerPlatformSideNavItem, DataSideNavItem, FreeToolsSideNavItem, HubspotCreditsSideNavItem, MarketingPlusSideNavItem, MarketingSideNavItem, SalesSideNavItem, ServiceSideNavItem } from './SideNavItems';
import { SideNavWrapper } from './SideNavWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SideNavContainer = () => {
  const sideNavVisibility = useSideNavVisibility();
  const {
    canViewMarketingPlus,
    canViewHubSpotCredits,
    canViewAddOns,
    canViewEnhancementsSection,
    canViewFreeTools,
    canViewBundlesPage
  } = sideNavVisibility;
  return /*#__PURE__*/_jsxs(SideNavWrapper, {
    children: [/*#__PURE__*/_jsxs(RouterSideNav, {
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.sidenav.sections.bundle"
      }),
      children: [/*#__PURE__*/_jsx(CustomerPlatformSideNavItem, {}), canViewFreeTools && /*#__PURE__*/_jsx(FreeToolsSideNavItem, {}), canViewBundlesPage && /*#__PURE__*/_jsx(BundleSideNavItem, {}), canViewMarketingPlus && /*#__PURE__*/_jsx(MarketingPlusSideNavItem, {})]
    }), /*#__PURE__*/_jsxs(RouterSideNav, {
      divider: true,
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.sidenav.sections.core`
      }),
      children: [/*#__PURE__*/_jsx(MarketingSideNavItem, {}), /*#__PURE__*/_jsx(SalesSideNavItem, {}), /*#__PURE__*/_jsx(ServiceSideNavItem, {}), /*#__PURE__*/_jsx(ContentSideNavItem, {}), /*#__PURE__*/_jsx(DataSideNavItem, {}), /*#__PURE__*/_jsx(CommerceSideNavItem, {})]
    }), canViewEnhancementsSection && /*#__PURE__*/_jsxs(RouterSideNav, {
      divider: true,
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.sidenav.sections.enhancements"
      }),
      children: [canViewHubSpotCredits && /*#__PURE__*/_jsx(HubspotCreditsSideNavItem, {}), canViewAddOns && /*#__PURE__*/_jsx(AddOnsSideNavItem, {})]
    }), /*#__PURE__*/_jsx(CurrencyPickerContainer, {})]
  });
};